import { Container } from "react-bootstrap";

import CoursesListTable from "../CoursesList/CoursesListTable";
import { useCourseRegistration } from "../../services/CourseRegistrationProvider";

const RegistrationAccordionBody = () => {
	const { registeredCourses } = useCourseRegistration();
	return (
		<Container className="py-4">
			<h3 className="text-center text-blue fw-bold fs-20 mb-4">
				{
					registeredCourses?.length > 0
						? "These are the classes you are registering for:"
						: "You are not currently registering for any courses."
				}
			</h3>

			{
				registeredCourses?.length > 0 && (
					<CoursesListTable
						courses={registeredCourses}
						selectable={false}
					/>
				)
			}
		</Container>
	);
};

export default RegistrationAccordionBody;
